module.exports = __webpack_public_path__ + "img/lotto.b203c21.webp";